// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ebab6fea","453":"319aa5d5","732":"de3315ba","977":"59662751"}[chunkId] + ".chunk.js";
};